import { useMemo } from 'react'
import { ItemFilter, MediaItem } from '../types'
import useFetchItems from './use-fetch-items'

type UseMediaResult = {
  items: MediaItem[]
  loading: boolean
  error: boolean
}

function sortMediaItems(items: MediaItem[]): MediaItem[] {
  const withHighlight = items.filter((item): item is MediaItem & { highlightOrder: number } =>
    typeof item.highlightOrder === 'number'
  )
  const withoutHighlight = items.filter((item) => typeof item.highlightOrder !== 'number')

  withHighlight.sort((a, b) => a.highlightOrder - b.highlightOrder)
  withoutHighlight.sort((a, b) => (b.date > a.date ? 1 : b.date < a.date ? -1 : 0))

  return [...withHighlight, ...withoutHighlight]
}

export default function useMedia(options: ItemFilter = {}): UseMediaResult {
  const { items, loading, error } = useFetchItems<MediaItem>('getMedia', 'media', options as Record<string, string | number | undefined>);

  const sortedItems = useMemo(() => sortMediaItems(items), [items])

  return { items: sortedItems, loading, error };
}

